module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "flexContainer contentBuilderModule"
  }, [_c('section', {
    attrs: {
      "id": "moduleDetailsSection"
    }
  }, [(_vm.item !== null) ? _c('div', {
    attrs: {
      "id": "moduleInfo"
    }
  }, [_c('h2', {
    staticClass: "uppercase h2Title",
    attrs: {
      "id": "moduleName"
    }
  }, [_vm._v(_vm._s(_vm.item.terms.name.en.value) + " / " + _vm._s(_vm.item.terms.name.fr.value))]), _vm._v(" "), _c('h2', {
    staticClass: "uppercase h2Title",
    attrs: {
      "id": "reference"
    }
  }, [_vm._v(_vm._s(_vm.diamRef1) + " / " + _vm._s(_vm.clientRef1))])]) : _vm._e(), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "fw-w",
    attrs: {
      "id": "relImgContainer"
    }
  }, _vm._l((_vm.products), function(n) {
    return _c('div', {
      key: n.id,
      staticClass: "relatedProductImage"
    }, [_c('div', {
      staticClass: "relatedImage rel fd-c jc-fs",
      attrs: {
        "id": "relatedImage"
      }
    }, [(n.figures.big !== null) ? _c('img', {
      staticClass: "block imagePrincipal",
      attrs: {
        "src": _vm.getImgPath(n.figures.big, 'big'),
        "width": "200",
        "alt": ""
      }
    }) : _vm._e(), _vm._v(" "), _c('h3', {
      staticClass: "uppercase bold refRelated"
    }, [_c('span', [_vm._v(_vm._s(n.terms.name["en"]["value"]) + " / " + _vm._s(n.terms.name["fr"]["value"]))]), _vm._v(" "), _c('img', {
      staticClass: "pointer",
      attrs: {
        "src": require("../../assets/link_icon.svg"),
        "height": "15",
        "alt": ""
      },
      on: {
        "click": function($event) {
          _vm.link(n);
        }
      }
    })])])])
  })), _vm._v(" "), _c('CommentBloc', {
    attrs: {
      "appId": 2,
      "commentData": _vm.commentData
    }
  })], 1), _vm._v(" "), _c('svg', {
    attrs: {
      "id": "builderModule"
    }
  })])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "headerPanel"
  }, [_c('p', [_vm._v("Products on module")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-615ce0c9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/plano/GroupEditor.vue
// module id = 3221
// module chunks = 0